const Checkbox = ({ type = "checkbox", className = "", ...props }) => {
  return (
    <input
      type="checkbox"
      className={`checkbox border-[1px] border-edge-hex-aaaaaa opacity-100 dark:border-edge-hex-aaaaaa80 checked:border-0 ${className}`}
      {...props}
    />
  );
};

export default Checkbox;
